/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPSWITCHOUTTYPE = {
    Percentage100Only: 'P',
    Amount: 'A'
} as const;
export type IAPSWITCHOUTTYPE = typeof IAPSWITCHOUTTYPE[keyof typeof IAPSWITCHOUTTYPE];


export function IAPSWITCHOUTTYPEFromJSON(json: any): IAPSWITCHOUTTYPE {
    return IAPSWITCHOUTTYPEFromJSONTyped(json, false);
}

export function IAPSWITCHOUTTYPEFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPSWITCHOUTTYPE {
    return json as IAPSWITCHOUTTYPE;
}

export function IAPSWITCHOUTTYPEToJSON(value?: IAPSWITCHOUTTYPE | null): any {
    return value as any;
}

